<div class="component-main-container">
  <app-page-header parentTitle="{{ 'meters.meters-label' | translate }}"
    pageTitle="{{ 'meters.generate-meters-label' | translate }}">
  </app-page-header>

  <div class="row">
    <div class="col-lg-5 col-xl-4 col-sm-12">
      <div class="component-forms-box">
        <app-register-form></app-register-form>

        <!-- Sessão de Filtro de medidores -->
        <div class="form-fields-box" [ngClass]="!filterMetersBox ? 'closed' : ''" [formGroup]="filterMetersForm">
          <h2 (click)="filterMetersOpen()">
            {{ "meters.filter-meters" | translate }}
          </h2>
          <hr [ngClass]="!filterMetersBox ? 'hr-open' : ''" />
          <div class="form-step">
            <div class="circle-number">1</div>
            <mat-form-field appearance="outline">
              <mat-label> {{ "meters.label-keyword" | translate }} </mat-label>
              <input matInput formControlName="keyword" #search />
            </mat-form-field>
          </div>

          <div class="form-step">
            <div class="circle-number">2</div>
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "meters.select-meters-type" | translate }}
              </mat-label>
              <mat-select formControlName="metersType" #type=matSelect>
                @for (item of metersTypeList; track item) {
                  <mat-option [value]="item.id">
                    {{ item.reference }}
                  </mat-option>
                }
                @if (metersTypeLoading$ | async) {
                  <mat-option>
                    <mat-spinner [diameter]="30"></mat-spinner>
                  </mat-option>
                }
                @if (metersTypeList.length === 0) {
                  <mat-option>
                    {{ "meters.select-option-meters-types" | translate }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="d-flex m-2">
            @if (!filterMetersLoading) {
              <button class="btn btn-success m-1 w-50"
                (click)="filterMeters(search.value, type.value)">
                {{ "meters.button-filter" | translate }}
              </button>
            }
            @if (filterMetersLoading) {
              <mat-spinner [diameter]="30"></mat-spinner>
            }
            <button class="btn btn-secondary m-1 w-50" (click)="resetFilter()">
              {{ "meters.button-reset-filter" | translate }}
            </button>
          </div>
        </div>

        <!-- sessão de Registro de medidores -->
        <div class="form-fields-box" [ngClass]="!registerMetersBox ? 'closed' : ''" [formGroup]="createMetersForm">
          <h2 (click)="registerMetersOpen()">
            {{ "meters.register-meters" | translate }}
          </h2>
          <hr [ngClass]="!registerMetersBox ? 'hr-open' : ''" />

          <div class="form-step">
            <div class="circle-number">1</div>
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "meters.label-serial-number" | translate }}
              </mat-label>
              <input matInput formControlName="serialNumber" />
            </mat-form-field>
          </div>
          <div class="form-step">
            <div class="circle-number">2</div>
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "meters.label-filter-meters-types" | translate }}
              </mat-label>
              <mat-select formControlName="type" #metersId (valueChange)="metersTypeGetId(metersId.value)">
                @for (item of metersTypeList; track item) {
                  <mat-option [value]="item.id">
                    {{ item.reference }}
                  </mat-option>
                }

                @if (metersTypeLoading$ | async) {
                  <mat-option>
                    <mat-spinner [diameter]="30"> </mat-spinner>
                  </mat-option>
                }
                @if (metersTypeList.length === 0) {
                  <mat-option>
                    {{ "meters.select-option-meters-types" | translate }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <div class="form-step">
            <div class="circle-number">3</div>
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "meters.label-filter-installations" | translate }}
              </mat-label>

              <mat-select formControlName="installations" #installationId
                (valueChange)="installationGetId(installationId.value)">
                @for (item of installationList; track item) {
                  <mat-option [value]="item.id">
                    {{ item.reference }}
                  </mat-option>
                }

                @if (installationLoading$ | async) {
                  <mat-option>
                    <mat-spinner [diameter]="30"> </mat-spinner>
                  </mat-option>
                }

                @if (installationList.length === 0) {
                  <mat-option>
                    {{ "meters.select-option-installations" | translate }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          @if (!registerMetersLoading) {
            <button class="btn btn-success" (click)="createMeters()">
              {{ "meters.button-save" | translate }}
            </button>
          }
          @if (registerMetersLoading) {
            <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>
      </div>
    </div>

    <!-- Sessão do cabeçalho da tabela -->
    @if (ELEMENT_DATA.length) {
      <div class="col-lg-7 col-xl-8 col-sm-12">
        <app-table-header [itensNumber]="ELEMENT_DATA.length" [totalNumber]="ELEMENT_DATA.length" [hasCSV]="true"
        [hasPDF]="true"></app-table-header>
        <div class="table-div mt-2 mt-lg-3 mt-lg-3">
          @if (metersLoading$ | async) {
            <mat-progress-bar mode="query">
            </mat-progress-bar>
          }
          <!-- Sessão da tabela -->
          <p-table [value]="ELEMENT_DATA" [tableStyle]="{ 'min-width': '65rem' }" [paginator]="true" dataKey="id"
            [rows]="10" [showPageLinks]="false" [showFirstLastIcon]="false">
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="serialNumber"> {{ "meters.serial-number-table" | translate }}
                </th>
                <th pSortableColumn="typeMeters"> {{ "meters.meters-type-table" | translate }}
                </th>
                <th pSortableColumn="installations"> {{ "meters.installations-table" | translate }}
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row let-columns="columns" let-ri="rowIndex">
              <tr>
                <td>{{row.serialNumber}}</td>
                <td>{{row.materialTypes}}</td>
                <td>{{row.installation}}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    }
  </div>
</div>